import { render, staticRenderFns } from "./ResourceImage.vue?vue&type=template&id=09c2759d&scoped=true&"
import script from "./ResourceImage.vue?vue&type=script&lang=js&"
export * from "./ResourceImage.vue?vue&type=script&lang=js&"
import style0 from "./ResourceImage.vue?vue&type=style&index=0&id=09c2759d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c2759d",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/elements/ResourceImage.vue
// module id = null
// module chunks = 